import React from 'react'
import { useFormContext, Controller } from 'react-hook-form'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import FormControl from '@material-ui/core/FormControl'
import MenuItem from '@material-ui/core/MenuItem'
import Box from '@material-ui/core/Box'
import {
  CtrlBirthDate,
  EmailFieldWithSuggestions,
  PhoneField,
} from 'components/form-util'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import useStyles from './group-event-registration-form.styles'
import { genderOptions } from 'lib/form-schemas/common'
import Grid from '@material-ui/core/Grid'
import InviteLockableTextField from '../invite-lockable-text-field'
import {
  emailsMatch,
  INVITE_EMAIL_MISMATCH_MESSAGE,
  useInviteEmailMismatch,
  useRegistrationInvite,
} from '../registration-invite'

const ParticipantInformation = () => {
  const { control, register, errors, watch } = useFormContext()

  const classes = useStyles()
  const { isValid: inviteIsValid, email: inviteEmail } = useRegistrationInvite()
  const inviteEmailMismatch = useInviteEmailMismatch()
  const lockIdentity = inviteIsValid && !inviteEmailMismatch
  const emailDiffersFromInvite =
    inviteIsValid && !emailsMatch(watch('student.email'), inviteEmail)
  const emailErrors = emailDiffersFromInvite
    ? {
      ...errors,
      student: {
        ...errors?.student,
        email: { message: INVITE_EMAIL_MISMATCH_MESSAGE },
      },
    }
    : errors

  return (
    <>
      <Typography variant="h5" style={{ marginBottom: '16px' }}>
        Participant Information
      </Typography>
      <Typography
        variant="body2"
        color="textSecondary"
        style={{ marginBottom: '16px' }}
      >
        *Indicates required fields
      </Typography>
      <Box>
        <Grid container spacing={2}>
          <Grid xs={6} item>
            <InviteLockableTextField
              name="student.firstName"
              locked={lockIdentity}
              lockedValue={watch('student.firstName')}
              error={!!errors?.student?.firstName}
              helperText={errors?.student?.firstName?.message}
              label="First name"
              fullWidth
              className={classes.input}
              required
            />
          </Grid>
          <Grid xs={6} item>
            <InviteLockableTextField
              name="student.lastName"
              locked={lockIdentity}
              lockedValue={watch('student.lastName')}
              error={!!errors?.student?.lastName}
              helperText={errors?.student?.lastName?.message}
              label="Last name"
              fullWidth
              className={classes.input}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <EmailFieldWithSuggestions
              name="student.email"
              control={control}
              errors={emailErrors}
              label="Email"
              classes={classes}
              disabled={lockIdentity}
              fullWidth
              required
            />
          </Grid>
          <Grid item xs={12}>
            <PhoneField
              name="student.phone"
              inputRef={register}
              error={!!errors?.student?.phone}
              helperText={errors?.student?.phone?.message}
              label="Phone Number"
              fullWidth
              className={classes.input}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <CtrlBirthDate
              name="student.dateOfBirth"
              control={control}
              errors={errors}
              label="Date of Birth"
              className={classes.input}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <FormControl
              error={!!errors?.student?.gender}
              variant="outlined"
              className={classes.input}
              required
            >
              <InputLabel id="pga-hope-golf-history-label">Gender</InputLabel>
              <Controller
                as={
                  <Select
                    labelId="pga-hope-golf-history-label"
                    label="Gender"
                    value=""
                  >
                    {genderOptions.map(opt => (
                      <MenuItem key={opt.value} value={opt.value}>
                        {opt.label}
                      </MenuItem>
                    ))}
                  </Select>
                }
                name="student.gender"
                control={control}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="student.zipCode"
              inputRef={register}
              error={!!errors?.student?.zipCode}
              helperText={errors?.student?.zipCode?.message}
              label="Zip Code"
              fullWidth
              className={classes.input}
              required
            />
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default ParticipantInformation
